<template>
  <div class="">
    <!-- header section start  -->
    <section class="text-center">
      <p
        class="mb-0 font-extrabold text-base md:text-xl"
        style="color: #8a94a6"
      >
        Pricing
      </p>
      <h2 class="text-black font-black tracking-wide text-2xl md:text-4xl">
        Plans to help you grow your business
      </h2>
    </section>
    <!-- header section end   -->
    <!-- pricing table  -->
    <section class="mt-10">
      <section
        class="flex flex-wrap justify-center mt-10 md:mt-16 md:justify-between md:px-20 lg:px-0"
      >
        <div
          class="mt-5 xl:mt-0"
          v-for="(cardData, index) in pricingTable"
          :key="index + cardData.title"
        >
          <pricing-card-new
            :cardData="cardData"
            :activeTab="activeTab"
            :index="index"
          />
        </div>
        <!-- contact us hight ticket  -->
        <!-- <div
          :class="[
            'border rounded-3xl p-5 flex-1 max-h-40',
            false ? ' border-primaryColor border-4' : 'border-gray-300',
          ]"
          style="max-width: 290px"
        >
          <h4
            :class="[
              'text-xl font-semibold',
              false ? ' text-primaryColor ' : ' text-gray-800',
            ]"
          >
            high-ticket
          </h4>
          <a
          href="https://twitter.com/messages/14603308-1448512543505272835?recipient_id=14603308"
          target="_blank"
            :class="[
              'btn w-full hover:bg-primaryColor mt-5',
              false ? ' btn-primary ' : 'btn-outline',
            ]"
          >
            Contact Us
          </a>
        </div> -->
      </section>
    </section>
  </div>
</template>

<script>
import PricingCardNew from './PricingCardNew.vue';

export default {
  components: { PricingCardNew },
  name: 'PricingTable',
  layout: 'null',
  data() {
    return {
      activeTab: 'yearly',
      pricingTable: [
        {
          title: 'Free',
          description: 'Figure out Twitter',
          monthly: '0',
          yearly: '$0',
          onFocus: false,
          keyPoints: [
            {
              title: 'Powerful list building',
            },
            {
              title: 'Bulk Engagement tools',
            },
            {
              title: 'Group & Manage DMs',
            },
          ],
        },
        {
          title: 'Creator',
          description: 'Manage relationships with easy',
          monthly: '15',
          yearly: '$9-$49',
          onFocus: false,
          keyPoints: [
            {
              title: 'Powerful list building',
            },
            {
              title: 'Bulk Engagement tools',
            },
            {
              title: 'Group & Manage DMs',
            },
            {
              title: 'Integrated Pipelines, Notes & Reminders',
            },
            {
              title: 'DM Nurturing, Sequences & Bots',
            },
            {
              title: 'Upto 5,000 managed contacts',
            },
          ],
        },
        {
          title: 'Business',
          description: 'Scale up building relationships',
          monthly: '29',
          yearly: '$247',
          onFocus: false,
          keyPoints: [
            {
              title: 'Powerful list building',
            },
            {
              title: 'Bulk Engagement tools',
            },
            {
              title: 'Group & Manage DMs',
            },
            {
              title: 'Integrated Pipelines, Notes & Reminders',
            },
            {
              title: 'DM Nurturing, Sequences & Bots',
            },
            {
              title: 'Unlimited managed contacts',
            },
            {
              title: 'Relationship Automation tools',
            },
            {
              title: 'Managed Workflows for 2+ users',
            },
            {
              title: 'Best practices & custom strategy calls',
            },
          ],
        },
      ],
    };
  },
};
</script>

<style>
</style>
